import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { AppConfigService } from '../core/app-config/app-config.service';
import { Subject } from 'rxjs';
import { SessionConfiguration } from '../shared/models/configuration.model';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class InactivityService {
  private readonly sessionConfiguration: SessionConfiguration | undefined;

  public onIdleStart$: Subject<boolean> = new Subject<boolean>();
  public onIdleEnd$: Subject<boolean> = new Subject<boolean>();
  public onTimeoutWarning$: Subject<number> = new Subject<number>();
  public onTimeOut$: Subject<number> = new Subject<number>();
  public timedOut = false;

  constructor(
    private readonly idle: Idle,
    private readonly appConfigService: AppConfigService
  ) {
    this.sessionConfiguration = appConfigService.configuration.sessionConfiguration;

    // Sets an Idle timeout period in seconds
    if (this.sessionConfiguration.idleTime) {
      idle.setIdle(this.sessionConfiguration.idleTime);
    }

    // sets a Timeout period in seconds. After Idle+Timeout seconds of inactivity, the user will be considered timed out
    if (this.sessionConfiguration.logoutWarningWaitingTime) {
      idle.setTimeout(this.sessionConfiguration.logoutWarningWaitingTime);
    }
    // });

    // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    this.onIdleStart$ = idle.onIdleStart;
    this.onIdleEnd$ = idle.onIdleEnd;
    this.onTimeOut$ = idle.onTimeout;
    this.onTimeoutWarning$ = idle.onTimeoutWarning;

    idle.onIdleEnd.subscribe(() => {
      this.reset();
    });

    idle.onTimeout.subscribe(() => {
      this.timedOut = true;
    });

    this.reset();
  }

  private reset(): void {
    this.idle.watch();
    this.timedOut = false;
  }
}
